<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:36:37+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe Language switcher
@Last modified by:   tom
@Last modified time: 2018-03-28T16:29:28+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Install:   npm install -save vue-cookie vue-i18n

Example:

-->

<template>
  <div class="locale-switcher">
    <!-- {{ initLocale() }} -->
    <b-nav-item-dropdown :dropup="dropup" :text="dropdownLbl" right>
      <b-dropdown-item
        v-for="locale in locales"
        :key="locale.id"
        class="locale-link"
        :class="{ 'is-current': locale === activeLocale }"
        href="#"
        @click="setLocale(locale)"
      >
        {{ getLanguageString(locale) }}
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>

import Vue from 'vue'
// Restore locale from cookie, if it was set
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

const localeStrings = {
  en: 'English',
  nl: 'Nederlands',
  ru: 'Russian',
  ua: 'Ukrainian',
  fr: 'Français',
  de: 'Deutsch'
}

// Vue.config.lang = VueCookie.get('locale') || 'en'
// console.log("Locale from cookie = " + Vue.config.lang + ": language = " + localeStrings[Vue.config.lang])

export default {
  props: {
    locales: {
      type: Array,
      default: () => ['en']
    },
    showFull: {
      type: Boolean,
      default: false
    },
    dropup: {
      type: Boolean,
      default: false
    },
    locLabel: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      activeLocale: Vue.config.lang
    }
  },
  computed: {
    dropdownLbl: function () {
      return this.locLabel ? this.locLabel : this.activeLocale
    }
  },
  methods: {
    setLocale: function (locale) {
      Vue.config.lang = locale
      this.activeLocale = locale
      this.$cookie.set('locale', locale, { expires: '1Y' })

      this.$i18n.locale = Vue.config.lang
      console.log('New locale = ' + Vue.config.lang + ': language = ' + localeStrings[Vue.config.lang])
    },
    getLanguageString: function (locale) {
      return this.showFull ? localeStrings[locale] : locale
    }
  }
}
</script>

<style lang="scss">

  .locale-switcher {
    display: inline-block;
    color: white;
    .dropdown-menu {
      font-size: 0.7em;
      background-color: $secondaryMedium;
      padding: 2px;
      .dropdown-item {
        cursor: pointer;
        text-transform: uppercase;;
        text-decoration: underline;
        font-variant: small-caps;
        font-family: $font-family-monospace;
        font-weight: lighter !important;
        text-decoration: none;
        color: $primaryWhite;
        &.is-current{
          background-color: $primaryHighlight;
          cursor:  default;
        }
      }
      .dropdown-item:hover,
      .dropdown-item:focus {
        background-color: $secondaryLight;

      }
      a, a:hover {
        text-decoration: none;
        color: $primaryWhite !important;;
      }
    }

  }

</style>
